import { useRootStore } from './useRootStore';

export function useUIStore() {
  const { UIStore } = useRootStore();
  return UIStore;
}
